import Reveal from './Reveal';
import { quickSteps } from '../content';

export default function QuickStart() {
  return (
    <section id="quickstart" className="scroll-mt-24 bg-[#F7F4EC] py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-display text-xs tracking-[0.35em] text-emerald-700 uppercase">Quick Start · 新手入门</p>
            <h2 className="mt-3 text-2xl font-bold tracking-tight text-stone-900 md:text-4xl">
              第一次打开，先做这四步
            </h2>
            <p className="mt-4 text-sm leading-7 text-stone-500 md:text-[15px]">
              吃瓜软件新手入门其实比想象中简单。别急着研究所有功能，按下面四步走一遍，十分钟就能进入状态。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {quickSteps.map((step, i) => (
            <Reveal key={step.num} delay={i * 90}>
              <article className="group flex h-full flex-col rounded-xl bg-white p-6 transition-colors hover:bg-emerald-50/60">
                <span className="font-display text-3xl font-semibold text-stone-300 transition-colors group-hover:text-emerald-600">
                  {step.num}
                </span>
                <span className="mt-6 flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-semibold text-stone-900">{step.title}</h3>
                <p className="mt-2 text-sm leading-6 text-stone-500">{step.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}